import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

// ТОП ТУРНИРЫ (баннеры)
export const getBanners = () => dispatch => {
	Xhr.getBanners().then((resp) => {
		dispatch({
			type : ACTIONS.TOP_TOURNEYS.GET,
			data : resp ? resp.data : [],
		})
	});
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/top-tourneys.js